/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_IntroInputs */

const en_blog_intro = /** @type {(inputs: Blog_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical guides to choosing, building and running AI systems for everyday work.`)
};

const lv_blog_intro = /** @type {(inputs: Blog_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktiski norādījumi, kā izvēlēties, izveidot un uzturēt AI sistēmas ikdienas darbam.`)
};

/**
* | output |
* | --- |
* | "Practical guides to choosing, building and running AI systems for everyday work." |
*
* @param {Blog_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_intro = /** @type {((inputs?: Blog_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_intro(inputs)
	return en_blog_intro(inputs)
});